import { gql } from '@apollo/client';

export const GET_SERVICE_PROVIDERS = gql`
  query GetServiceProviders {
    serviceProviders {
      id
      name
    }
  }
`;
